import React, { useState } from 'react';
import styles from './GroupSetting.module.css';
import CloseBtn from '../../elemets/CloseBtn/CloseBtn';
import Checkbox from '../../elemets/Checkbox/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { onChangeGroupRedux } from '../../store/slices/groupsSlice';
import { updateDocBd } from '../../firebase';
import LoaderPage from '../LoaderPage/LoaderPage';
export default function GroupSetting({ setShowGroupSetting, group_id }) {
  const dispatch = useDispatch();
  const [loaderPage, setLoaderPage] = useState(false);

  const groups = useSelector((state) => state.groups.groupsList);

  const getGroup = (groups, group_id) => {
    for (let index = 0; index < groups.length; index++) {
      const group = groups[index];

      if (group.group_id === group_id) {
        return group;
      }
    }
  };

  const isActive = (group, sortValue) => {
    if (group && group.sortValue && group.sortValue === sortValue) {
      return true;
    }
    return false;
  };

  const onChangeGropValue = async (value) => {
    setLoaderPage(true);
    const isUpdate = await updateDocBd('groupsList', group_id, 'sortValue', value);
    if (isUpdate) {
      dispatch(onChangeGroupRedux({ group_id, item: 'sortValue', value: value }));
      setLoaderPage(false);
      return;
    }
    alert('Не вдалося оновити дані');
    setLoaderPage(false);
  };

  const onChangeGropTest = async () => {
    onChangeGropValue('grop_test');
  };
  const onChangeGropDraft = () => {
    onChangeGropValue('grop_draft');
  };
  const onChangeGropGrops = () => {
    onChangeGropValue('grop_grops');
  };
  const onChangeGropIndividual = () => {
    onChangeGropValue('grop_individual');
  };
  const onChangeGropFree = () => {
    onChangeGropValue('grop_free');
  };

  return (
    <div className={styles.groupSetting_wrapper}>
      <div className={styles.close_btn_wrapper}>
        <CloseBtn handleClick={setShowGroupSetting} />
      </div>
      <div className={styles.grop_sort_wrapper}>
        <div className={'df aic gap_10 mb_15'}>
          <Checkbox
            ifSelected={isActive(getGroup(groups, group_id), 'grop_grops')}
            handleClick={onChangeGropGrops}
          />
          Груповий супровід
        </div>
        <div className={'df aic gap_10 mb_15'}>
          <Checkbox
            ifSelected={isActive(getGroup(groups, group_id), 'grop_individual')}
            handleClick={onChangeGropIndividual}
          />
          Індивідуальний супровід
        </div>
        <div className={'df aic gap_10 mb_15'}>
          <Checkbox
            ifSelected={isActive(getGroup(groups, group_id), 'grop_free')}
            handleClick={onChangeGropFree}
          />
          Безкоштовной супровід
        </div>
        <div className={'df aic gap_10 mb_15'}>
          <Checkbox
            ifSelected={isActive(getGroup(groups, group_id), 'grop_draft')}
            handleClick={onChangeGropDraft}
          />
          Чорновик
        </div>
        <div className={'df aic gap_10 '}>
          <Checkbox
            ifSelected={isActive(getGroup(groups, group_id), 'grop_test')}
            handleClick={onChangeGropTest}
          />
          Для тестування
        </div>
      </div>
      {loaderPage && <LoaderPage />}
    </div>
  );
}
